import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

import { AuthService } from '../auth.service';
import { ModalService } from '../modules/modal/modal.service';
import { Message } from '../models/message';
import { MessageModalComponent } from '../components/message/message-modal.component';
import { SessionTimeoutConstants } from '../constants';

@Injectable()
export class IdleService {
  timeoutMessage: Message;
  
  constructor(
    private _idle: Idle,
    private _modalService: ModalService,
    private _authService: AuthService,
  ) {}

  public init(): void {
    this._idle.setIdle(SessionTimeoutConstants.TIME_LENGTHS.IDLE);
    this._idle.setTimeout(SessionTimeoutConstants.TIME_LENGTHS.TIMEOUT);
    this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this._idle.watch();
  }

  public subscribe(): void {
    this._idle.onTimeout.subscribe(() => {
      this._idle.stop();
      this._authService.logout();
    });

    this._idle.onIdleStart.subscribe(() => {
      this.timeoutMessage = {
        title: SessionTimeoutConstants.INACTIVE_SESSION,
        content: '',
      } as Message;
      this._modalService.openModal({
        component: MessageModalComponent,
        data: this.timeoutMessage
      });
    });

    this._idle.onTimeoutWarning.subscribe((countdown) => {
      const minutesIdle = Math.floor(SessionTimeoutConstants.TIME_LENGTHS.IDLE / 60);
      const minutesToTimeout = Math.floor(countdown / 60);
      const secondsToTimeout = countdown % 60;
      this.timeoutMessage.content = `Your session has been inactive for ${minutesIdle} minutes. You will be logged out in ${minutesToTimeout} minutes and ${secondsToTimeout} seconds. Please click "Ok" to reset your status`;
    });
  }
}